import PrismicClient from "./prismic-api";
import Prismic from "prismic-javascript";
import {compact} from "lodash";

const fetchSinglePage = async (pageName, tags) => {
  //try getting content by tags
  const prismicData = await PrismicClient.query([
    Prismic.Predicates.at("document.type", pageName),
    // Prismic.Predicates.at('document.tags', tags)
  ]).then((res) => {
    return res.results[0];
  });
  if (prismicData) {
    // console.log("returned tagged data")
    return prismicData;
    //if the queried page exists, it will be returned
  } else {
    const prismicData = await PrismicClient.query([
      Prismic.Predicates.at("document.type", pageName),
      Prismic.Predicates.at("document.tags", ["master"]),
    ]).then((res) => {
      return res.results[0];
    });
    if (prismicData) {
      // console.log("returned master data")
      return prismicData;
      //if there is no match by state, or med/rec, it will return the master content
    } else {
      // console.log("returned false data")
      return false;
      //if there is no master content, it returns false
    }
  }
};

const fetchSingleByUID = async (postType, pageUID) => {
  try {
    const prismicDocument = await PrismicClient.getByUID(postType, pageUID);
    if (prismicDocument) {
      return prismicDocument;
    } else {
      console.warn("error, not found etc.");
    }
  } catch (error) {
    console.error(error);
  }
};

const fetchRepeatable = async (postType, max) => {
  const prismicData = await PrismicClient.query(
    [
      Prismic.Predicates.at("document.type", postType),
      Prismic.Predicates.not("document.tags", ["exclude"]),
    ],
    {pageSize: !max ? 100 : max}
  ).then((res) => {
    return res.results;
  });
  if (prismicData) {
    return prismicData;
  }
};

const fetchListByIDs = async (ids) => {
  const prismicData = await PrismicClient.query([
    Prismic.Predicates.in("document.id", compact(ids)),
  ]).then((res) => res.results);
  if (prismicData) {
    return prismicData;
  }
};

export {fetchSingleByUID, fetchRepeatable, fetchSinglePage, fetchListByIDs};
